import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import useInterval from '../../useInterval';
import { Button } from 'reactstrap';
import styles from './TaskLoadingButton.module.css';
import qs from 'qs';

import {
  setProductImportProgressView,
  setProductImportLoadingView,
  fetchProductImportProgress,
  dismissProductImportProgress
} from '../productActions';
import {
  setPriceUpdateProgressView,
  setPriceUpdateLoadingView,
  fetchPriceUpdateProgress,
  dismissPriceUpdateProgress
} from '../ProductPriceUpdate/productPriceActions';
import {
  setSpecialPriceUpdateProgressView,
  setSpecialPriceUpdateLoadingView,
  fetchSpecialPriceUpdateProgress,
  dismissSpecialPriceUpdateProgress
} from '../SpecialPriceUpdate/specialPriceActions';

import { getUserProfile } from '../../myAccount/profileActions';

import { setFeatureFlag } from '../../../reducers/ThemeOptions';

export default function TaskLoadingButton({ limitRoutes = [], children }) {
  const dispatch = useDispatch();
  const { authenticated } = useSelector((state) => state.auth);
  const {
    isAutoSync
  } = useSelector((state) => state.ThemeOptions);
  const isShopifyUser = localStorage.getItem('isShopifyUser')=='true' ? true : false;
  let show = false;
  let isLogoutPage = false
  if(window.location.pathname.toLowerCase() =='/logout'){
    isLogoutPage = true;
  }
  const location = useLocation();
  if (!location || !location.pathname) {
    show = false;
  } else {
    if (limitRoutes && limitRoutes.length) {
      for (let route of limitRoutes) {
        if (!route.startsWith('/')) {
          route = '/' + route;
        }
        if (route.toUpperCase() === location.pathname.toUpperCase()) {
          show = true;
          break;
        }
      }
    } else {
      show = true;
    }
  }

  const { isProductImportRunning, isProductImportLoadingShow } = useSelector(
    (state) => state.productCatalogue
  );
  const { isPriceUpdateRunning, isPriceUpdateLoadingShow } = useSelector(
    (state) => state.productPrice
  );
  const {
    isPriceUpdateRunning: isSpecialPriceUpdateRunning,
    isPriceUpdateLoadingShow: isSpecialPriceUpdateLoadingShow
  } = useSelector((state) => state.specialPrice);

  const handleClick = () => {
    dispatch(setProductImportProgressView(true));
    dispatch(setProductImportLoadingView(false));
    dispatch(fetchProductImportProgress(true));

    dispatch(setPriceUpdateProgressView(true));
    dispatch(setPriceUpdateLoadingView(false));
    dispatch(fetchPriceUpdateProgress(true));

    dispatch(setSpecialPriceUpdateProgressView(true));
    dispatch(setSpecialPriceUpdateLoadingView(false));
    dispatch(fetchSpecialPriceUpdateProgress(true));
  };


  // Poll every 5 seconds while a product import is actively running
  useInterval(
    () => {
      dispatch(fetchProductImportProgress(true));
    },
    authenticated && isShopifyUser && isProductImportRunning ? 5000 : null
  );

  useEffect(() => {
    // Always check product import progress on page load/navigation
    // Price updates only checked if auto-sync is disabled
    if (authenticated && !isLogoutPage && isShopifyUser) {
      setTimeout(() => {
        if (authenticated) {
          // Always check product import progress
          dispatch(fetchProductImportProgress(true));
          
          // Only check price updates if auto-sync is disabled
          if (isAutoSync === false) {
            dispatch(fetchPriceUpdateProgress(true));
            dispatch(fetchSpecialPriceUpdateProgress(true));
          }
        }
      }, 2000);
    }
  }, [dispatch, authenticated, location.pathname, isAutoSync, isLogoutPage, isShopifyUser]);

  const productImportLoading =
    isProductImportRunning && isProductImportLoadingShow;
  const priceUpdateLoading = isPriceUpdateRunning && isPriceUpdateLoadingShow;
  const specialPriceUpdateLoading =
    isSpecialPriceUpdateRunning && isSpecialPriceUpdateLoadingShow;

  // Debug: Log the states to help identify the issue
  useEffect(() => {
    console.log('TaskLoadingButton Debug:', {
      isAutoSync,
      show,
      isShopifyUser,
      productImportLoading,
      priceUpdateLoading,
      specialPriceUpdateLoading,
      isProductImportRunning,
      isProductImportLoadingShow,
      authenticated,
      pathname: location.pathname,
      shouldShowSpinner: show && isShopifyUser && (
        productImportLoading || 
        (!isAutoSync && (priceUpdateLoading || specialPriceUpdateLoading))
      )
    });
  }, [
    isAutoSync,
    show,
    isShopifyUser,
    productImportLoading,
    priceUpdateLoading,
    specialPriceUpdateLoading,
    isProductImportRunning,
    isProductImportLoadingShow,
    authenticated,
    location.pathname
  ]);

  // Show spinner button if:
  // 1. Product import is loading (always show, regardless of auto-sync)
  // 2. OR (price updates are loading AND auto-sync is disabled)
  const shouldShowSpinner = 
    show && 
    isShopifyUser && 
    (
      productImportLoading || 
      (!isAutoSync && (priceUpdateLoading || specialPriceUpdateLoading))
    );

  if (shouldShowSpinner) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <Button
            color="info"
            className={`btn-spinner ${styles.btn}`}
            onClick={handleClick}>
            <span
              className="btn-wrapper--icon spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"></span>
          </Button>
          {children}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
